export default __webpack_public_path__ + "static/media/photo--sm--116.c6e992c7.jpg";